import colors from '../colors';

const badgeSize = '12px';

const badge = {
  MuiBadge: {
    styleOverrides: {
      root: {
        '& .MuiBadge-badge': {
          fontSize: badgeSize,
          fontWeight: 'bold',
          height: badgeSize,
          minWidth: badgeSize,
          padding: '8px 5px',
          right: '-10px',
          top: '8px',
        },

        '& .MuiBadge-dot': {
          borderRadius: badgeSize,
          outline: `2px solid ${colors.palette.primary.main}`,
          padding: 0,
          right: '2px',
          top: '6px',
        },
      },
    },
  },
};

export default badge;
